import {UiBaseIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M14.775 16.458c2.458-1.15 3.975-3.275 3.975-6.458 0-3.183-1.625-5.45-4.233-6.567C13.267 1.333 11.425 0 9.375 0c-2.05 0-3.892 1.333-5.142 3.433C1.625 4.55 0 6.708 0 10c0 3.292 1.625 5.45 4.233 6.567C5.483 18.667 7.325 20 9.375 20c2.05 0 3.833-1.292 5.083-3.333.709.883 2.85 2.366 5.542 3.333v-3.542h-5.225Zm-.442-.183c-1.4.592-3.083.892-4.958.892s-3.567-.292-4.958-.892C3.533 14.558 3 12.375 3 10c0-2.375.533-4.558 1.417-6.275 1.4-.592 3.083-.892 4.958-.892s3.567.292 4.958.892c.884 1.717 1.417 3.9 1.417 6.275 0 2.375-.533 4.558-1.417 6.275Z",
      class: "finq-icon"
    }, null, -1)
  ])))
}
export default { render() { return h(UiBaseIcon, {icon: {render}, name: "finq-logo"}) } }